import { AutoCompleteOption } from "./types";

export const mapAutoCompleteOption = <TOption, T extends TOption | undefined>(
  option: T,
  valueProp?: keyof TOption,
  labelProp?: keyof TOption
): T extends undefined
  ? AutoCompleteOption<TOption> | undefined
  : AutoCompleteOption<TOption> => {
  if (!option) {
    return option as never;
  }

  return {
    ...option,
    ...(valueProp ? { value: option[valueProp]?.toString() } : {}),
    ...(labelProp ? { label: option[labelProp]?.toString() } : {}),
  } as unknown as AutoCompleteOption<TOption>;
};
